import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { resolve, reject, actionSet } from './utils'
import { getPages } from 'component/pagination/utils'

import { hideSpinner, showSpinner } from './spinner'

import {
  FETCH_ROTATIVE_INVENTORY_REQUEST,
  FETCH_ROTATIVE_INVENTORY_SUCCESS,
  FETCH_ROTATIVE_INVENTORY_ERROR,
  INACTIVATE_ROTATIVE_INVENTORY_SUCCESS,
  INACTIVATE_ROTATIVE_INVENTORY_ERROR,

  FETCH_ZERO_COST_DPAC_ITEMS_REQUEST,
  FETCH_ZERO_COST_DPAC_ITEMS_SUCCESS,
  FETCH_ZERO_COST_DPAC_ITEMS_ERROR,

  FETCH_ROTATIVE_INVENTORY_FLUX_REQUEST,
  FETCH_ROTATIVE_INVENTORY_FLUX_SUCCESS,
  FETCH_ROTATIVE_INVENTORY_FLUX_ERROR,

} from 'actionTypes'

const HAS_PAGINATION = true

export const fetchRotativeInventory =
  (token, params, getData, fetchError) => (dispatch) => {
    dispatch(actionSet(FETCH_ROTATIVE_INVENTORY_REQUEST))

    const actualPage = params.page || 1

    const pagination = {
      hasPagination: HAS_PAGINATION,
      offset: params.limit * actualPage - params.limit,
      page: actualPage,
      size: params.limit,
    }

    return new Api(token, dispatch)
      .post(API_URL.ROTATIVE_INVENTORY_FIND, {
        ...params,
        ...pagination,
      })
      .then(({ data }) => {
        dispatch(getPages(data.pages))
        dispatch(actionSet(FETCH_ROTATIVE_INVENTORY_SUCCESS, data.resultList))
        getData && getData(data)
      })
      .catch((error) => {

        dispatch(actionSet(FETCH_ROTATIVE_INVENTORY_ERROR, error))
        fetchError && fetchError()
      })
  }

  export const v2fetchRotativeInventory =
  (token, params, getData, fetchError, signalController) => (dispatch) => {
    dispatch(actionSet(FETCH_ROTATIVE_INVENTORY_REQUEST))

    const actualPage = params.page || 1

    const pagination = {
      hasPagination: HAS_PAGINATION,
      offset: params.limit * actualPage - params.limit,
      page: actualPage,
      size: params.limit,
    }


    const onClose = () => {
      dispatch(hideSpinner())
      dispatch(hideSpinner())
    }

    const onError = (error) => {
      dispatch(actionSet(FETCH_ROTATIVE_INVENTORY_ERROR, error))
      fetchError && fetchError()
    }

    const onMessage = (response) => {
      dispatch(getPages(response.data.pages))
      dispatch(actionSet(FETCH_ROTATIVE_INVENTORY_SUCCESS, response.data.resultList))
      getData && getData(response.data)
    }

    const abort = () => {
      signalController.abort()
      onClose()
    }

    dispatch(showSpinner("", true, abort))

    return new Api(token, dispatch)
      .eventSourceStream(API_URL.V2_ROTATIVE_INVENTORY_FIND, {
        ...params,
        ...pagination,
      }, null, signalController, onMessage, onClose, onError)
      .catch((error ) => onError(error))
      
  }

// INACTIVATE ROTATIVE_INVENTORYS BY IDINVENTORYCRITERIA
export const inactivateRotativeInventory =
  (token, idInventoryCriteria) => async (dispatch) => {
    const params = {
      idInventoryCriteria,
    }

    try {
      await new Api(token, dispatch).post(
        API_URL.ROTATIVE_INVENTORY_INACTIVATE,
        params
      )

      return resolve(dispatch, INACTIVATE_ROTATIVE_INVENTORY_SUCCESS)
    } catch (error) {
      return reject(dispatch, INACTIVATE_ROTATIVE_INVENTORY_ERROR, error)
    }
  }

// ZERO COST DPAC ITEMS
export const fetchZeroCostDpacItems =
  (token, params, callback, fetchError, signalController) => (dispatch) => {
    dispatch(actionSet(FETCH_ZERO_COST_DPAC_ITEMS_REQUEST))

    const actualPage = params.page || 1

    const pagination = {
      hasPagination: HAS_PAGINATION,
      offset: params.limit * actualPage - params.limit,
      page: actualPage,
      size: params.limit,
    }

    const onClose = () => {
      dispatch(hideSpinner())
      dispatch(hideSpinner())
    }

    const onError = (error) => {
      dispatch(actionSet(FETCH_ZERO_COST_DPAC_ITEMS_ERROR, error))
      fetchError && fetchError()
      onClose()
    }

    const onMessage = (response) => {
      dispatch(getPages(response.data.pages))
      dispatch(actionSet(FETCH_ZERO_COST_DPAC_ITEMS_SUCCESS, response.data.resultList))
      callback && callback(response.data.resultList, response.data.pages.totalCount)
      onClose()
    }

    const abort = () => {
      signalController.abort()
      onClose()
    }
  
    dispatch(showSpinner("", true, abort))

    return new Api(token, dispatch)
      .eventSourceStream(API_URL.ZERO_COST_DPAC_ITEMS_FIND, {
        ...params,
        ...pagination,
      }, null, signalController, onMessage, onClose, onError )
      .catch((error) => onError(error))
  }


  // ITEMS RESET IN THE COUNT OF THE DAY 
  export const fetchRotativeInventoryFlux =
  (token, params, getData, fetchError, signalController) => (dispatch) => {
    dispatch(actionSet(FETCH_ROTATIVE_INVENTORY_FLUX_REQUEST))

    const actualPage = params.page || 1

    const pagination = {
      hasPagination: HAS_PAGINATION,
      offset: params.limit * actualPage - params.limit,
      page: actualPage,
      size: params.limit,
    }

    const onMessage = (response) =>{
      dispatch(getPages(response.data.pages))
        dispatch(actionSet(FETCH_ROTATIVE_INVENTORY_FLUX_SUCCESS, response.data.resultList))
        getData && getData(response.data)
    }

    const onClose = () => {
      dispatch(hideSpinner())
      dispatch(hideSpinner())
    }

    const onError = (error) => {
      dispatch(actionSet(FETCH_ROTATIVE_INVENTORY_FLUX_ERROR, error))
      fetchError && fetchError(error)
    }

    const abort = () => {
      signalController.abort()
      dispatch(hideSpinner())
      dispatch(hideSpinner())
      onClose()
    }
  
    dispatch(showSpinner("", true, abort))

    return new Api(token, dispatch)
      .eventSourceStream(API_URL.ROTATIVE_INVENTORY_FLUX, {
        ...params,
        ...pagination,
      }, null, signalController, onMessage, onClose, onError)
      .catch((error) => onError(error))
  }